module.exports = __webpack_public_path__ + "images/emoji/sweat.5741396dc9d73f17b7fb.png";